import React, { Component } from 'react';
import { Route as Match } from 'react-router-dom';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { loadCollectionBuilding, loadRefBuilding } from 'actions/collections';
import BuildingComponent from 'components/Building';
import { loadBuilding } from 'actions/building';
import { getParams } from '../../components/Building/Main/helper';


class Building extends Component {

  state = {
    params: {}
  };

  componentDidMount() {
    const {
      loadCollectionBuilding,
      loadRefBuilding,
      loadBuilding,
      match: { params }
    } = this.props;

    if (params.base64) {
      try {
        getParams(params.base64).then(data => {
          if (params.id) {
            loadCollectionBuilding({
              buildingId: params.id,
              referal: data.r
            });
          } else {
            loadRefBuilding({
              selectionReferal: data.id
            });
          }
        });
      } catch (e) {
        window.location = '/';
      }
    } else if (params.id) {
      loadCollectionBuilding({
        buildingId: params.id,
        referal: params.referal
      });
    } else {
      loadRefBuilding({
        selectionReferal: params.referal
      });
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const {
      loadCollectionBuilding,
      match: { params }
    } = this.props;
    const { params: nextParams } = nextProps.match;
    if (params.id !== nextParams.id) {
      loadCollectionBuilding(nextParams.id);
      document.body.scrollTop = 0;
    }
  }

  render() {
    const { buildingForGallery, dispatch, building, user, selection, match, match: { params }, noPageExist } = this.props;
    return (
      <Match
        render={(matchProps) => (
          <div>
            <Match
              render={() =>
                <BuildingComponent.Main
                  {...matchProps}
                  dispatch={dispatch}
                  match={match}
                  params={params}
                  building={building}
                  buildingForGallery={buildingForGallery}
                  user={user}
                  selection={selection}
                  noPageExist={noPageExist}
                  client
                />
            }
            />
          </div>
      )}
      />
    );
  }
}

const mapStateToProps = createSelector(
  state => state.building,
  state => state.collection.building,
  state => state.collection.user,
  state => state.collection.selection,
  state => state.collection.noPageExist,
  state => state.building.data,
  (buildingForGallery, building, user, selection, noPageExist, building2) => ({
    buildingForGallery,
    building: {
      data: building || building2
    },
    user,
    selection,
    noPageExist
  })
);

const mapDispatchToProps = {
  loadCollectionBuilding,
  loadRefBuilding,
  loadBuilding
};

export default connect(mapStateToProps, mapDispatchToProps)(Building);



// WEBPACK FOOTER //
// ./src/containers/ClientBuilding/Building.js